import MarkRow from './MarkRow'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class MarksList extends Component {
  static defaultProps() {
    return {
      marks: this.props.marks
    }
  }

  static propTypes = {
    handleMarkClick: PropTypes.func.isRequired,
    marks: PropTypes.array,
    onMarkDelete: PropTypes.func.isRequired,
    onMarkSave: PropTypes.func.isRequired,
    videoLength: PropTypes.number.isRequired
  }

  render() {
    const {
      marks,
      handleMarkClick,
      onMarkSave,
      onMarkDelete,
      videoLength
    } = this.props

    if (marks.length === 0) {
      return <span className="grey-reg-i">{I18n.t('No marks provided')}</span>
    }
    return (
      <ul className="cursor">
        {marks.map(mark => (
          <MarkRow
            key={mark.id}
            mark={mark}
            handleClick={handleMarkClick}
            onSave={onMarkSave}
            onDelete={onMarkDelete}
            videoLength={videoLength}
          />
        ))}
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/MarksList.js